"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const gatsby_1 = require("gatsby");
const default_1 = __importDefault(require("./default"));
const seo_1 = __importDefault(require("../components/seo"));
var PostTemplate = function PostTemplate(_ref) {
    var markdownRemark = _ref.data.markdownRemark, pageContext = _ref.pageContext;
    var frontmatter = markdownRemark === null || markdownRemark === void 0 ? void 0 : markdownRemark.frontmatter;
    var title = (frontmatter === null || frontmatter === void 0 ? void 0 : frontmatter.title) || '';
    var date = (frontmatter === null || frontmatter === void 0 ? void 0 : frontmatter.date) || '';
    var html = (markdownRemark === null || markdownRemark === void 0 ? void 0 : markdownRemark.html) || '';
    var next = pageContext.next, prev = pageContext.prev;
    return /*#__PURE__*/ react_1.default.createElement(default_1.default, null, /*#__PURE__*/ react_1.default.createElement(seo_1.default, {
        title: title
    }), /*#__PURE__*/ react_1.default.createElement("article", null, /*#__PURE__*/ react_1.default.createElement("div", {
        className: "center"
    }, /*#__PURE__*/ react_1.default.createElement("h1", {
        className: "title"
    }, title), /*#__PURE__*/ react_1.default.createElement("span", {
        className: "code"
    }, /*#__PURE__*/ react_1.default.createElement("small", null, date))), /*#__PURE__*/ react_1.default.createElement("div", {
        className: "divider"
    }), /*#__PURE__*/ react_1.default.createElement("div", {
        dangerouslySetInnerHTML: {
            __html: html
        }
    })), /*#__PURE__*/ react_1.default.createElement("div", {
        className: "page-navigation code"
    }, /*#__PURE__*/ react_1.default.createElement("span", null, " \xB7 "), /*#__PURE__*/ react_1.default.createElement(gatsby_1.Link, {
        to: "/",
        className: "home",
        title: "Back Home"
    }, " ", "Home", " "), /*#__PURE__*/ react_1.default.createElement("span", null, " \xB7 ")));
};
exports.default = PostTemplate;
var pageQuery = "4090317422";
